if (__DEV__) {
    var Immutable = require('nuclear-js').Immutable;
    var installDevTools = require('immutable-devtools');
    installDevTools(Immutable);
}


import React from 'react';
import popover from 'utils/popover';
import Features from 'utils/features';
import AppRoutes from './routes';
import Reactor from 'data/reactor';
import { capturePrintEvent } from './utils/screen-print-utils';
import { createRoot } from 'react-dom/client';
import LanguageContext, { dictionaries } from 'resources/stringLocale';
import Stores from 'data/stores';
import SessionStorageUtils from 'data/session-storage/utils';
import { BrowserRouter } from 'react-router-dom';
import { AuthManager } from './authentication';
import getEnvironmentSettings from './resources/setting'
import ErrorPage from 'ErrorPage';
import NWEAError from 'ErrorPage/NWEAError';
import _AuthUtils from 'utils/auth';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

require('./reporting.less');

Reactor.registerStores(Stores);
SessionStorageUtils.loadStores();

let app = document.createElement('div');
app.id = 'app';
app.className = 'content-wrapper';
document.body.insertBefore(app, null);
window.addEventListener('keyup', popover.closePopoverBoxesOnEscape);
window.addEventListener('keydown', capturePrintEvent);
window.addEventListener('resize', () =>
    document.documentElement.style.setProperty('--viewport-width', window.innerWidth)
); // Update CSS --viewport-width variable

// Browser and OS information on the HTML tag is used for browser specific styling fixes
document.getElementsByTagName('html')[0].className = `${Features.getBrowserName()} ${Features.getOS()}`;
document.documentElement.style.setProperty('--viewport-width', window.innerWidth); // Initialize the CSS --viewport-width variable

const container = document.getElementById('app');
const root = createRoot(container);
const baseNamePrefix = __DEV__ ? '/' : '/nextgen-report';
const envURL=()=> {
    let envName = "prod";
    if (window.location.href.indexOf("orf01")> -1)
        envName ="orf";
    else if (window.location.href.indexOf("int03") > -1 )
         envName ="integration";
    else if (window.location.href.indexOf("perf01") > -1)
        envName = "perf";
    else if (window.location.href.indexOf("localhost") > -1)
        envName = "local"  ;
    else
    envName = "prod";
    console.log("envURL envName ::"+envName)
    return envName;
};
const env = envURL();

const App = {
    
   

    AuthManagerSettings() {
        /* Enable OIDC logging
         *  pass in OIDC_LOGGING level or boolean
         *  LEVEL: NONE = 0, ERROR = 1, WARN = 2, INFO = 3, DEBUG = 4;
         */
        const OIDC_LOGGING = ['development', 'orf', 'integration'].includes(env) ? 3 : 0;
        return {
            UPDATE_FN: App.updateAuthToken,
            OIDC_LOGGING,
            ...getEnvironmentSettings,
        };
    },

    
    init: async () => {

        if (!localStorage.getItem('datadogRumInitialized')){
            console.log('Initializing Datadog Rum');
            datadogRum.init({
                applicationId: '9d8dfeec-67be-4e30-a20c-4d78d2a80237',
                clientToken: 'pube1c9ff7aeb4fb5d511d3585c78ebf3fb',
                site: 'datadoghq.com',
                service: 'student-profile-v2',
                env: env,
                sessionSampleRate: env === 'prod' ? 5 : 100,
                sessionReplaySampleRate: 0,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: 'mask-user-input',
            });
            localStorage.setItem('datadogRumInitialized','true');
        }
        envURL();
        if (!__DEV__) {
            const authManagerSettings = App.AuthManagerSettings();
            App['AUTH_MANAGER'] = new AuthManager(authManagerSettings);
            if (App['AUTH_MANAGER'].session) {
                const isValidUser = _AuthUtils.isUserAuthorized(App['AUTH_MANAGER'].session.user.profile.uapRoles)
                if (isValidUser) {
                    sessionStorage.setItem("auth_session_Token", App['AUTH_MANAGER'].session.user.token);
                }
                root.render(
                    <BrowserRouter basename={baseNamePrefix}>
                        {
                            isValidUser ? (<AppRoutes />) : (<ErrorPage thrownError={new NWEAError({ code: '403', stringLocale: dictionaries.english })} />)
                        }
                    </BrowserRouter>
                );
            }
        }else {
            root.render(
                <BrowserRouter basename={baseNamePrefix}>
                    {
                        <AppRoutes />
                    }
                </BrowserRouter>
            )
        }
    }
}

window.onload = () => {
    
    if (!localStorage.getItem('datadogLogsInitialized')){
        console.info('Initializing Datadog Logs');
        datadogLogs.init({
            clientToken: 'pube1c9ff7aeb4fb5d511d3585c78ebf3fb',
            site: 'datadoghq.com',
            forwardErrorsToLogs: true,
            sampleRate: 100,
            env: env,
        });
        localStorage.setItem('datadogLogsInitialized', 'true');
    }
    App.init();
};